




















































import Vue from 'vue';
import 'vue-awesome/icons/chevron-left';
import 'vue-awesome/icons/chevron-right';
import Icon from 'vue-awesome/components/Icon.vue';
import Polaroid from '@/components/Polaroid.vue';

export default Vue.extend({
  name: 'PolaroidPhotoAlbum',
  components: {
    Polaroid,
    Icon,
  },
  props: {
    photos: Array,
    size: String,
    stacked: Boolean,
  },
  data() {
    return {
      photoIndex: 0,
      canMoveBack: false,
      canMoveForward: true,
    };
  },
  created() {
    this.canMove();
  },
  watch: {
    photoIndex() {
      this.canMove();
    },
  },
  methods: {
    prevPhoto() {
      if (this.photoIndex - 1 >= 0) {
        this.photoIndex--;
      }
    },
    nextPhoto() {
      if (this.photoIndex + 1 < this.photos.length) {
        this.photoIndex++;
      }
    },
    canMove() {
      this.canMoveBack = this.photoIndex > 0;
      this.canMoveForward = this.photoIndex + 1 !== this.photos.length;
    },
  },
});
